export const scaleImage = (url: string, deviceWidth: number, multiplier = 1) => {
    const w = getClosestBreakpoint(deviceWidth) * multiplier;
    return url?.split('?')[0] + `?w=${w}&mw=${w}`;
};

export const getScaledHeight: (imageHeight: number, imageWidth: number, deviceWidth: number, scalingMultiplier: number) => number = (imageHeight, imageWidth, deviceWidth, scalingMultiplier) => {
    const coefficient = imageHeight / imageWidth
    return Math.floor((deviceWidth * coefficient) * scalingMultiplier)
}
const getClosestBreakpoint = (width: number) => {
    if (width < 400) return 320;
    if (width < 600) return 480;
    if (width < 900) return 768;
    if (width < 1200) return 1024;
    if (width < 1440) return 1280;
    if (width < 1680) return 1440;
    if (width < 1920) return 1600;
    if (width < 2560) return 1920;
    if (width < 3840) return 2560;
    return 3840; // 4K e oltre
  };
  